<template>
  <div>
    <div class="check-all-holder" v-if="!hideSelection">
      <v-checkbox v-model="selectedAll" label="alle auswählen" @click="allCheckCLicked" :disabled="disableAllSelectedCheckbox"></v-checkbox>
      <v-btn
        v-if="getSelectedTasks.length > 0"
        color="red"
        class="ml-4"
      @click="showDeletePopup = true"
        :disabled="mySelectedItems.length > 0 && mySelectedItems.length === tableData.length"
      >
       Löschen
    </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      :sort-by="['date']"
      :sort-desc="[true]"
      :show-select="showSelect"
      :singleSelect="singleSelect"
      item-key="id"
      :page.sync="pageHistory"
      v-model="mySelectedItems"
      :search="performSearch"
      :footer-props="{'items-per-page-text':'Zeilen pro Seite'}"
      :options="sortOptions"
      @update:page="pageChange"
      @update:sort-by="(e) => sortByHandler(e, SortPages.Task)"
      @update:sort-desc="(e) => sortDescHandler(e, SortPages.Task)">
      <template #item.buttons="{item}">
        <div class="buttons-holder">
          <!-- <v-icon
            v-for="action in actions"
            :key="action.id"
            :disabled="isButtonDisabled(action, item)"
            @click="$emit(action.action, item)"
            class="green--text custom-action-icon"
            >{{ action.icons }}</v-icon
          > -->
          <img v-for="action in actions"
            v-show="!isButtonDisabled(action, item)"
            :key="action.id"
            :class="isButtonDisabled(action, item) ? 'disabled' : ''"
            @click="$emit(action.action, item)"
            class="green--text custom-action-icon" v-bind:src="action.icons" />
        </div>
      </template>

      <template v-slot:body.prepend="{ headers }">
        <tr v-show="getSelectedTasks.length > 0">
          <td v-for="(header, i) in headers" :key="i">
            <div v-if="i == 0">
              Total:
            </div>
            <div
              v-if="header.value == 'specialHours'"
              class="custom-green-text"
            >
              {{ totalSpecialHours + " h" }}
            </div>

            <div v-if="header.value == 'normalHours'" class="custom-green-text">
              {{ totalNormalHours + " h" }}
            </div>

            <div v-if="header.value == 'material'" class="custom-green-text">
              {{ totalMaterial + " Fr." }}
            </div>

            <div v-else>
              <!-- empty table cells for columns that don't need a sum -->
            </div>
          </td>
        </tr>
      </template>

      <template v-slot:item.date="{ item }">
        <div v-if="item.date">
          <v-icon class="custom-calendar-icon"
            >mdi-calendar-blank-outline</v-icon
          >
          <span>{{ item.date | formatDate }}</span>
        </div>
      </template>

      <template v-slot:item.finishDate="{ item }">
        <div v-if="item.finishDate">
          <v-icon class="custom-calendar-icon"
            >mdi-calendar-blank-outline</v-icon
          >
          <span>{{ item.finishDate | formatDate }}</span>
        </div>
      </template>

      <template v-slot:item.colorTypeId="{ item }">
        <span :class="getColorClass(item.colorTypeId)"></span>
      </template>

      <template v-slot:item.treeName="{ item }">
        <div v-if="item.treeName" class="d-flex">
          <img v-if="item.treeId != 0" class="custom-map-area-icon" src="../../assets/images/icons/baumliste.svg" />
          <v-icon v-else class="custom-map-area-icon">
            mdi-texture-box
          </v-icon>
          <span>{{ item.treeName}}</span>
        </div>
      </template>
      <template v-slot:item.tasksFinishedUsers="{ item }">
        <div v-if="item.tasksFinishedUsers.length > 0">
          <div
            class="acc-name-duration"
            v-for="user in item.tasksFinishedUsers"
          >
            <span class="acc-name" :title="user.firstName + ' ' + user.lastName">
              <span class="initials">
               {{ user.initials ? user.initials : (user.firstName[0].toUpperCase() + user.lastName[0].toUpperCase()) }}
              </span>
            </span>
          </div>
          <div v-if="item.freelanceName && item.freelanceLastName" class="acc-name-duration">
            <span class="acc-name" :title="item.freelanceName + ' ' + item.freelanceLastName">
              <span class="initials">
                {{ getInitials(item.freelanceName, item.freelanceLastName) }}
              </span>
            </span>
          </div>
        </div>
      </template>
      <template v-slot:item.info="{ item }">
          <span v-if="item.isFinished">
          <span v-if="item.finishInfo !== null">
            <v-tooltip top :offset="10"> <!-- Adjust the offset value as needed -->
              <template v-slot:activator="{ on, attrs }">
                <img class="custom-map-area-icon cursor-pointer" src="../../assets/images/icons/info.svg" v-bind="attrs" v-on="on" />
              </template>
              <span>{{ item.finishInfo }}</span> <!-- Tooltip content -->
            </v-tooltip>
          </span>
          </span>
          <span  v-else-if="item.info != null">
            <v-tooltip top :offset="10"> <!-- Adjust the offset value as needed -->
              <template v-slot:activator="{ on, attrs }">
                <img class="custom-map-area-icon cursor-pointer" src="../../assets/images/icons/info.svg" v-bind="attrs" v-on="on" />
              </template>
              <span>{{ item.info }}</span> <!-- Tooltip content -->
            </v-tooltip>
          </span>
        </template>

      <template #header.data-table-select="{ }"> </template>

      <template #item.data-table-select="{ item, isSelected }">
        <v-checkbox
          v-if="!hideSelection"
          color="#1DB954"
          v-model="mySelectedItems"
          :value="item"
        ></v-checkbox>
      </template>
    </v-data-table>

    <div class="delete-popup" v-show="showDeletePopup" ref="deletePopup">
      <div class="popup-holder">
        <v-icon size="36" class="close-popup" @click="showDeletePopup = false"
          >mdi mdi-close</v-icon
        >

        <p class="title">Eintrag loschen</p>

        <div class="description-holder">
          <v-icon color="#C82210" class="popup-icon"
            >mdi mdi-trash-can-outline</v-icon
          >

          <p class="description">
            Möchten Sie diese wirklich löschen? Diese Aktion kann
            nicht rückgängig gemacht werden.
          </p>
        </div>

        <div class="buttons">
          <v-btn
            size="x-large"
            height="54px"
            class="cancel-btn"
            @click="showDeletePopup = false"
          >
            Abbrechen
          </v-btn>

          <v-btn
            size="x-large"
            height="54px"
            color="#c82210"
            class="delete-btn"
            @click="deleteTasks"
          >
            Löschen
          </v-btn>
        </div>
      </div>
    </div>
    <CustomLoader v-show="isLoading" />

  </div>

</template>

<script>
import { eventBus } from "../../main";
import { mapActions, mapGetters } from 'vuex'
import CustomLoader from "../../components/custom_components/CustomLoader.vue";
import axios from "axios";
import sortMixin from '../../mixins/sortMixin'
import { SortPages } from '../../consts/Sorts'

export default {
  props: ["pageNumber","headers", "tableData", "actions", "showSelect", "singleSelect", "userCanView", "userCanEdit", "userCanDelete","hideSelection"],
  mixins: [sortMixin],
  components: {
        CustomLoader
  },
  data() {
    return {
      totalSpecialHours: 0,
      totalNormalHours: 0,
      totalMaterial: 0,
      selectedAll: false,
      pageNumbers:4,
      currentPage: 1,
      showDeletePopup: false,
      isLoading: false,
      SortPages: SortPages
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", 'getSelectedTasks']),
    performSearch() {
      return this.getSearchquery;
    },
    mySelectedItems: {
      get() {
        if (this.singleSelect)
          return [this.getSelectedTasks[this.getSelectedTasks.length - 1]];
        return this.getSelectedTasks;
      },
      set(value) {
        if (typeof value !== "object") this.setSelectedTasks([value]);
        else this.setSelectedTasks(value);
      }
    },
    lockedRowClass() {
      return item => (item.isLocked ? "locked-row" : "");
    },
    pageHistory: {
      get() {
        const savedPage = JSON.parse(localStorage.getItem('tableTasksCurrentPage'));
        if (this.tableData.length > 0 && savedPage !== null) {
          return savedPage;
        } else {
          return 1;
        }
      },
      set(value) {
        localStorage.setItem('tableTasksCurrentPage', value);
      }
    },
    disableAllSelectedCheckbox() {
      if (this.mySelectedItems.length > 0 && this.mySelectedItems.length !== this.tableData.length){
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    getSelectedTasks: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.calculateSumOfColumns();
        }
      }
    },
    tableData: function (newVal){
      if (newVal.length > 0 && this.getSelectedTasks.length > 0)
        this.selectedAll = this.getSelectedTasks?.length === newVal.length;
    }
  },
  mounted() {
    eventBus.$on("resetSelectedTasks", () => (this.setSelectedTasks([])));
    this.setInitialSort(SortPages.Task)
    this.mySelectedItems = this.getSelectedTasks
    this.calculateSumOfColumns()
  },
  destroyed() {
    eventBus.$off("resetSelectedTasks");
  },
  methods: {
    ...mapActions(['setSelectedTasks']),
    getColorClass(colorType) {
      switch (colorType) {
        case 1:
          return 'circle red-circle';
        case 2:
          return 'circle green-circle';
        case 3:
          return 'circle blue-circle';
        case 4:
          return 'circle yellow-circle';
        case 5:
          return 'circle gray-circle';
        default:
          return 'circle gray-circle';
      }
    },
     pageChange(newPage) {
      localStorage.setItem("tableTasksCurrentPage", newPage);
    },
    allCheckCLicked() {
      if(this.selectedAll === true) {
        this.setSelectedTasks(this.tableData);
        this.$emit('selectedRow', this.mySelectedItems);
      } else {
        this.setSelectedTasks([]);
      }
    },
    calculateSumOfColumns() {
      /* special hours sum */
      const sumOfSpecialHours = this.getSelectedTasks.reduce(
        (accumulator, currentItem) => {
          return accumulator + currentItem.specialHours;
        },
        0
      );

      /* normal hours sum */
      const sumOfNormalHours = this.getSelectedTasks.reduce(
        (accumulator, currentItem) => {
          return accumulator + currentItem.normalHours;
        },
        0
      );

      /* material sum */
      const sumOfMaterial = this.getSelectedTasks.reduce(
        (accumulator, currentItem) => {
          return accumulator + currentItem.material;
        },
        0
      );

      this.totalSpecialHours = sumOfSpecialHours;
      this.totalNormalHours = sumOfNormalHours;
      this.totalMaterial = sumOfMaterial;
    },

    isButtonDisabled(action, item) {

      /* if user can view from backend and action is view, dont disable button */
      /* if user can edit, and action is edit, and the task is not finished, dont disable button */
      if(this.userCanView === true && action.action === "view") {
        return false;
      } else if (this.userCanEdit === true && action.action === "edit") {
        if(!item.isFinished) {
          return false;
        }
        if(item.finishDate) {
          const finishDate = new Date(item.finishDate);
          const today = new Date();
          const diffInTime = today - finishDate;
          const diffInDays = diffInTime / (1000 * 3600 * 24);
          console.log(diffInDays);
          if (diffInDays < 10) {
            return false;
          }
        }
        return true;
      } 
      return true;
    },

    /* function that provides initials and handles if name or surname has spaces */
    getInitials(name, surname) {
      let nameInitials = "";
      if (name) {
        nameInitials = name
          .split(" ")
          .map(n => n.charAt(0))
          .join("");
      }
      let surnameInitials = "";
      if (surname) {
        surnameInitials = surname
          .split(" ")
          .map(n => n.charAt(0))
          .join("");
      }
      return (nameInitials + surnameInitials).toUpperCase() || "";
    },

    async deleteTasks() {
          if (!this.getSelectedTasks || this.getSelectedTasks.length === 0) {
            alert("No tasks selected for deletion.");
            return;
          }
          this.isLoading = true;
          const taskIds = this.getSelectedTasks.map(item => item.id);

          try {
            const response = await axios.delete("/api/Tasks/Delete", {
              data: taskIds,
            });

            if (response.status === 200 && response.data.success) {
              this.$emit('removeTasks', taskIds);
              await this.setSelectedTasks([]);
              this.selectedAll = false;
              this.showDeletePopup = false;
            } else {
              alert("Failed to delete tasks: " + response.data.message);
            }
          } catch (error) {
            alert("Error deleting tasks: " + error.message);
          } finally {
            this.isLoading = false;
          }
        }

  }
};
</script>

<style lang="scss">
/* Red */
.red-circle {
  background-color: #c82210;
}

/* Green */
.green-circle {
  background-color: #1db954;
}

/* Blue */
.blue-circle {
  background-color: #118afa;
}

/* Yellow */
.yellow-circle {
  background-color: #fff500;
}

/* Gray */
.gray-circle {
  background-color: gray;
}

.circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
}
.check-all-holder {
  padding-left: 16px;
  padding-top: 16px;
  display: flex;
  align-items: center;
}
.custom-action-icon {
  border: 1px solid #494949;
  padding: 8px;
  border-radius: 5px;
  width: 42px;
  height: 42px;

  &::after {
    border-radius: 5px;
    width: 42px;
    height: 42px;
    transform: scale(1);
  }
}

.custom-green-text {
  color: #1db954;
}

.custom-calendar-icon {
  margin-right: 5px;
}

.buttons-holder {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.acc-name-duration {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  .acc-name {
    text-transform: capitalize;
    display: flex;
    align-items: center;

    .initials {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #494949;
      padding: 8px;
      border-radius: 100%;
      margin-right: 10px;
      text-transform: uppercase;
      font-size: 10px;
      font-weight: 500;
      color: #1db954;
      width: 36px;
      height: 36px;
      cursor: default;
    }
  }

  .duration {
    margin-left: 46px;
  }
}
.popup,
.confirm-popup,
.delete-popup,
.cancel-popup {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.3);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;

  .popup-holder {
    display: flex;
    flex-direction: column;
    background-color: #1c1e1c;
    width: 662px;
    height: auto;
    max-height: 78vh;
    max-height: 80%;
    border-radius: 10px;
    padding: 30px;
    position: relative;

    .close-popup {
      position: absolute;
      right: 30px;
      top: 25px;
      cursor: pointer;
    }

    .title {
      text-align: center;
    }

    .description-holder {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      height: 200px;

      .popup-icon {
        margin-bottom: 20px;
        font-size: 50px;
      }

      .description {
        font-size: 18px;
        line-height: 25px;
        margin-bottom: 0;
        text-align: center;
      }
    }

    .work-types,
    .baums {
      height: 100%;
      max-height: 304px;
      overflow-y: auto;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 3px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: transparent;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #1db954;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: darken($color: #1db954, $amount: 5);
      }

      .custom-radio {
        padding: 20px 0;
        border-bottom: 1px solid #494949;
      }
    }

    .buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 30px;

      .submit-btn {
        width: 285px;
        color: #000;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        text-transform: none;
        background-color: #1db954;
      }

      .delete-btn {
        width: 285px;
        color: #fff;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        text-transform: none;
        background-color: #c82210;
      }

      .cancel-btn {
        width: 285px;
        color: #fff;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        text-transform: none;
        background-color: transparent;
        border: 1px solid #fff;
      }
    }
  }
}
</style>
